import React, { FC } from "react";
import "./LoadingPage.scss";
import LeopartLoader from "../LeopartLoader/LeopartLoader";

interface ILoadingPage {}

const LoadingPage: FC<ILoadingPage> = () => {
  return (
    <div className="d-flex flex-1 justify-content-center align-items-center">
      <LeopartLoader size="lg" />
    </div>
  );
};

export default LoadingPage;
